export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REDIRECT_BASE_URL = process.env.REACT_APP_REDIRECT_BASE_URL;

export const EMAIL_REGEX =
  /^(?!.*\.\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]{1,63}(\.[a-zA-Z]{2,})+$/;
export const MOBILE_REGEX = /^\d{10}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const URL_REGEX =
  /^((https?|ftp):)\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-line
export const EMAIL_MOBILE_REGEX =
  /^(?:(?!.*\.\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+|(?:\+?\d{1,3})?[\s\-]?\d{10})$/; // eslint-disable-line

export const FACEBOOK_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(facebook|meta)\.com\/(?:[a-zA-Z0-9_.-]+(?:\/[a-zA-Z0-9_.-]+)*)\/?$/i;
export const INSTAGRAM_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(instagram|meta)\.com\/[a-zA-Z0-9_.-]+\/?$/i;
export const YOUTUBE_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/(@[a-zA-Z0-9_-]+|(?:channel|c)\/[a-zA-Z0-9_-]+)(\?[^#]*)?$/i;
export const LINKEDIN_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9_-]+\/?$/i;

export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY_DEMO;

export const PROCESS_STEPS = [
  "select-membership",
  "membership-form",
  "application-review",
  "checkout",
  "payment-success",
];
export const RENEW_STEPS = ["plan-status", "checkout", "thank-you"];
export const ADMIN_STEPS = [
  "membership",
  "membership-form",
  "application-review",
];
